import React from 'react';
import { FooterTemplate } from 'themes/components';

function Footer() {
	return <FooterTemplate />;
}

export default Footer;



// WEBPACK FOOTER //
// ./src/core/components/Footer.jsx